module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.$parent.isAdminPage(_vm.$route.path, _vm.$route.name)) ? _c('div', {
    staticClass: "sidebar"
  }, [(_vm.userinfo.user_level === 'admin') ? _c('nav', {
    staticClass: "sidebar-nav"
  }, [_c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/dashboard",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-speedometer"
  }), _vm._v(" Dashboard\n                ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item nav-dropdown"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items nav-dropdown-items-left"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/company',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-suitcase"
  }), _vm._v(" View All\n                        ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/company/add'
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add\n                        ")])], 1)])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item nav-dropdown"
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items nav-dropdown-items-left"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/usersadmin',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" View All\n                        ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/usersadmin/add'
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add\n                        ")])], 1)])])])]) : _c('nav', {
    staticClass: "sidebar-nav"
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.current_top_menu === 'retail execution'),
      expression: "current_top_menu === 'retail execution'"
    }],
    staticClass: "nav"
  }, [(_vm.is_master === true || (_vm.is_manager === true || _vm.is_client === true)) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(dashboard)')
    }
  }, [_c('router-link', {
    class: ['nav-link'],
    attrs: {
      "to": {
        path: '/retailer-execution',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-chart-bar"
  }), _vm._v("Activities\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.is_manager === true || _vm.is_client === true)) ? _c('li', {
    staticClass: "nav-item nav-dropdown",
    class: {
      'open': _vm.active_actions
    }
  }, [_vm._m(2), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items",
    class: {
      'nav-dropdown-items-left': !_vm.active_actions, 'dbimportant': _vm.active_actions
    }
  }, [(_vm.is_master === true || (_vm.permissions.indexOf('136') >= 0 && _vm.features.indexOf('visit') >= 0)) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(visits)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/visits',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-street-view"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-title",
    attrs: {
      "title": "Visits"
    }
  }, [_vm._v("Visits")])])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.permissions.indexOf('136') >= 0 && _vm.features.indexOf('visit') >= 0)) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(visit-calendar)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/visit-calendar',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "far fa-calendar-alt"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-title",
    attrs: {
      "title": "Visit Calendar"
    }
  }, [_vm._v("Calendar")])])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.is_manager === true || _vm.is_client === true)) ? _c('li', {
    staticClass: "nav-item nav-dropdown",
    class: {
      'open': _vm.active_reports
    }
  }, [_vm._m(3), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items",
    class: {
      'nav-dropdown-items-left': !_vm.active_reports, 'dbimportant': _vm.active_reports
    }
  }, [(_vm.is_master === true || ((_vm.features.indexOf('retailer_reports') >= 0) && _vm.is_client === false)) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(visit-report2)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/visit-report2',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-title",
    attrs: {
      "title": "Retailer Report"
    }
  }, [_vm._v("Visit Report")])])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.features.indexOf('retailer_reports') >= 0)) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(photo-gallery-report)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/photo-gallery-report',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-images"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-title",
    attrs: {
      "title": "Retailer Report"
    }
  }, [_vm._v("Photo Gallery Report")])])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.features.indexOf('store_audit') >= 0)) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(store-audit-report)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/store-audit-report'
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "far fa-calendar-check"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-title",
    attrs: {
      "title": "Store Audit "
    }
  }, [_vm._v("Store Audit ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.permissions.indexOf('140') >= 0)) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(task-report)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/task-report'
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-tasks"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-title",
    attrs: {
      "title": "Task Report"
    }
  }, [_vm._v("Task Report")])])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.permissions.indexOf('140') >= 0)) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(historical-taskreport)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/historical-taskreport'
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-history"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-title",
    attrs: {
      "title": "Historical Report"
    }
  }, [_vm._v("Historical Report")])])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(no-visit-location-report)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/no-visit-location-report?page=1'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-thumbtack"
  }), _vm._v(" Unplanned Visit\n                        ")])], 1), _vm._v(" "), (_vm.is_master === true || (_vm.permissions.indexOf('140') >= 0)) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(uncompleted-store-visits)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/uncompleted-store-visits',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "far fa-calendar-times"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-title",
    attrs: {
      "title": "Uncompleted Visits"
    }
  }, [_vm._v("Uncompleted Visits")])])], 1) : _vm._e(), _vm._v(" "), (_vm.is_manager === true) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(master-visit-report)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/master-visit-report'
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-list"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-title",
    attrs: {
      "title": "Master Report"
    }
  }, [_vm._v("Master Report")])])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.is_manager === true) ? _c('li', {
    staticClass: "nav-item nav-dropdown",
    class: {
      'open': _vm.active_locations
    }
  }, [_vm._m(4), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items",
    class: {
      'nav-dropdown-items-left': !_vm.active_locations, 'dbimportant': _vm.active_locations
    }
  }, [(_vm.is_master === true || (_vm.permissions.indexOf('12') >= 0 && _vm.features.indexOf('locations') >= 0)) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(locations)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/locations',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v(" Locations\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.permissions.indexOf('12') >= 0 && _vm.features.indexOf('location_map') >= 0)) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(location-map)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/location-map'
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-map-marker-alt"
  }), _vm._v(" Location Map\n                        ")])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.is_manager === true)) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(merchandisers)')
    }
  }, [_c('router-link', {
    class: ['nav-link', {
      'active': _vm.isActiveMenu(_vm.merchandiser_paths)
    }],
    attrs: {
      "to": {
        path: '/merchandisers',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-user-tie"
  }), _vm._v(" Merchandisers\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || _vm.is_manager === true) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(tasks)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/tasks',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-list-ol"
  }), _vm._v(" Tasks\n                ")])], 1) : _vm._e()]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.current_top_menu === 'stock-management-dashboard'),
      expression: "current_top_menu === 'stock-management-dashboard'"
    }],
    staticClass: "nav"
  }, [(_vm.is_master === true || (_vm.is_manager === true || _vm.is_client === true && (_vm.plan === 2 || _vm.plan === 3 || _vm.plan === 4))) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(dashboard)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/stock-management-dashboard",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-chart-bar"
  }), _vm._v(" Activities\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.is_manager === true || _vm.is_client === true && (_vm.plan === 2 || _vm.plan === 3 || _vm.plan === 4))) ? _c('li', {
    staticClass: "nav-item nav-dropdown",
    class: {
      'open': _vm.active_actions
    }
  }, [_vm._m(5), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items",
    class: {
      'nav-dropdown-items-left': !_vm.active_actions, 'dbimportant': _vm.active_actions
    }
  }, [(_vm.is_master === true || (_vm.permissions.indexOf('136') >= 0 && _vm.features.indexOf('visit') >= 0)) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(visits)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/visits',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-street-view"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-title",
    attrs: {
      "title": "Visits"
    }
  }, [_vm._v("Visits")])])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.permissions.indexOf('136') >= 0 && _vm.features.indexOf('visit') >= 0)) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(visit-calendar)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/visit-calendar',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "far fa-calendar-alt"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-title",
    attrs: {
      "title": "Visit Calendar"
    }
  }, [_vm._v("Calendar")])])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.is_manager === true || _vm.is_client === true && (_vm.plan === 2 || _vm.plan === 3 || _vm.plan === 4)) ? _c('li', {
    staticClass: "nav-item nav-dropdown",
    class: {
      'open': _vm.active_reports
    }
  }, [_vm._m(6), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items",
    class: {
      'nav-dropdown-items-left': !_vm.active_reports, 'dbimportant': _vm.active_reports
    }
  }, [(_vm.is_master === true || ((_vm.features.indexOf('retailer_reports') >= 0) && _vm.is_client === false)) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(visit-report2)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/visit-report2',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-title",
    attrs: {
      "title": "Retailer Report"
    }
  }, [_vm._v("Visit Report")])])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || _vm.is_manager === true || _vm.is_client === true) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(stock-take-reports)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/stock-take-reports',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-box"
  }), _vm._v(" Stock Take Report\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || _vm.is_manager === true || _vm.is_client === true) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(stock-take-photo-reports)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/stock-take-photo-reports',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-images"
  }), _vm._v(" Photo Gallery Report\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || ((_vm.is_manager === true || _vm.is_client === true) && (_vm.plan === 3 || _vm.plan === 4))) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(planogram-visit-reports)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/planogram-visit-reports',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "far fa-eye"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-title",
    attrs: {
      "title": "Planogram Report"
    }
  }, [_vm._v("Planogram Report")])])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || ((_vm.is_manager === true || _vm.is_client === true) && (_vm.plan === 3 || _vm.plan === 4))) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(oos-report)')
    }
  }, [(_vm.is_master === true || _vm.features.indexOf('sales') >= 0) ? _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/oos-report?page=1'
      }
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v(" OOS Report\n                        ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || ((_vm.is_manager === true || _vm.is_client === true) && _vm.plan === 4)) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(stock-take-management-reports)')
    }
  }, [(_vm.is_master === true || _vm.features.indexOf('promoters') >= 0) ? _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/stock-take-management-reports?page=1'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-user"
  }), _vm._v(" Promoter Stock Take\n                        ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || ((_vm.is_manager === true || _vm.is_client === true) && _vm.plan === 4)) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(stock-request-management-reports)')
    }
  }, [(_vm.is_master === true || _vm.features.indexOf('promoters') >= 0) ? _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/stock-request-management-reports?page=1'
      }
    }
  }, [_c('i', {
    staticClass: "far fa-plus-square"
  }), _vm._v(" Stock Request\n                        ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || ((_vm.is_manager === true || _vm.is_client === true) && _vm.plan === 4)) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(stock-receipt-management-reports)')
    }
  }, [(_vm.is_master === true || _vm.features.indexOf('promoters') >= 0) ? _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/stock-receipt-management-reports?page=1'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-clipboard-check"
  }), _vm._v(" Stock Receipt\n                        ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || ((_vm.is_manager === true || _vm.is_client === true) && _vm.plan === 4)) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(stock-transfer-management-reports)')
    }
  }, [(_vm.is_master === true || _vm.features.indexOf('promoters') >= 0) ? _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/stock-transfer-management-reports?page=1'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-exchange-alt"
  }), _vm._v(" Stock Transfer\n                        ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || ((_vm.is_manager === true || _vm.is_client === true) && _vm.plan === 4)) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(stock-receipt-erp-management-reports)')
    }
  }, [(_vm.is_master === true || _vm.features.indexOf('promoters') >= 0) ? _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/stock-receipt-erp-management-reports?page=1'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-clipboard-check"
  }), _vm._v(" Stock Receipt ERP\n                        ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.is_manager === true && _vm.plan === 4)) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(discrepancy-report)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/discrepancy-report'
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-balance-scale"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-title",
    attrs: {
      "title": "Discrepancy Report"
    }
  }, [_vm._v("Discrepancy Report")])])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.is_master === true || _vm.is_manager === true) ? _c('li', {
    staticClass: "nav-item nav-dropdown",
    class: {
      'open': _vm.active_locations
    }
  }, [_vm._m(7), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items",
    class: {
      'nav-dropdown-items-left': !_vm.active_locations, 'dbimportant': _vm.active_locations
    }
  }, [(_vm.is_master === true || (_vm.permissions.indexOf('12') >= 0 && _vm.features.indexOf('locations') >= 0)) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(locations)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/locations',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v(" Locations\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.permissions.indexOf('12') >= 0 && _vm.features.indexOf('location_map') >= 0)) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(location-map)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/location-map'
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-map-marker-alt"
  }), _vm._v(" Location Map\n                        ")])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.is_master === true || _vm.is_manager === true) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(merchandisers)')
    }
  }, [_c('router-link', {
    class: ['nav-link', {
      'active': _vm.isActiveMenu(_vm.merchandiser_paths)
    }],
    attrs: {
      "to": {
        path: '/merchandisers',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-user-tie"
  }), _vm._v(" Merchandisers\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || _vm.is_manager === true) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(tasks)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/tasks',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-list-ol"
  }), _vm._v(" Tasks\n                ")])], 1) : _vm._e()]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.current_top_menu === 'sales dashboard'),
      expression: "current_top_menu === 'sales dashboard'"
    }],
    staticClass: "nav"
  }, [(_vm.is_master === true || ((_vm.is_manager === true || _vm.is_client === true) && _vm.plan === 4)) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(dashboard)')
    }
  }, [_c('router-link', {
    class: ['nav-link'],
    attrs: {
      "to": {
        path: '/sales-dashboard',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-chart-bar"
  }), _vm._v("Activities\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.is_manager === true && _vm.plan === 4)) ? _c('li', {
    staticClass: "nav-item nav-dropdown",
    class: {
      'open': _vm.active_actions
    }
  }, [_vm._m(8), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items",
    class: {
      'nav-dropdown-items-left': !_vm.active_actions, 'dbimportant': _vm.active_actions
    }
  }, [(_vm.is_master === true || (_vm.permissions.indexOf('156') >= 0 && _vm.features.indexOf('promoters') >= 0)) ? _c('li', {
    class: ['nav-item', 'link-master-data', {
      'active-menu': _vm.isActiveMenu('(promoter-rosters)')
    }]
  }, [_c('router-link', {
    class: ['nav-link', {
      'active': _vm.isActiveMenu(_vm.promoter_roster_path)
    }],
    attrs: {
      "to": {
        path: '/promoter-rosters',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-street-view"
  }), _vm._v(" Roster\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.permissions.indexOf('156') >= 0 && _vm.features.indexOf('promoters') >= 0)) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(promoter-calendar)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/promoter-calendar',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "far fa-calendar-alt"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-title",
    attrs: {
      "title": "Roster Calendar"
    }
  }, [_vm._v("Roster Calendar")])])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.is_master === true || ((_vm.is_manager === true || _vm.is_client === true) && _vm.plan === 4)) ? _c('li', {
    staticClass: "nav-item nav-dropdown",
    class: {
      'open': _vm.active_reports
    }
  }, [_vm._m(9), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items",
    class: {
      'nav-dropdown-items-left': !_vm.active_reports, 'dbimportant': _vm.active_reports
    }
  }, [(_vm.is_master === true || (_vm.permissions.indexOf('156') >= 0 && _vm.features.indexOf('promoters') >= 0)) ? _c('li', {
    class: ['nav-item', 'link-master-data', {
      'active-menu': _vm.isActiveMenu('(promoter-roster-report)')
    }]
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/promoter-roster-report',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-user-clock"
  }), _vm._v(" Attendance\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.permissions.indexOf('156') >= 0 && _vm.features.indexOf('promoters') >= 0)) ? _c('li', {
    class: ['nav-item', 'link-master-data', {
      'active-menu': _vm.isActiveMenu('(non-clocked-employee-reports)')
    }]
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/non-clocked-employee-reports',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-exclamation-circle"
  }), _vm._v(" Non Clocked\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.permissions.indexOf('158') >= 0 && _vm.features.indexOf('sales') >= 0)) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(salesreport)')
    }
  }, [(_vm.is_master === true || _vm.features.indexOf('sales') >= 0) ? _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/salesreport?page=1'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-file-invoice-dollar"
  }), _vm._v("Sales Report\n                        ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.is_client !== true) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(commission-report)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/commission-report',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-piggy-bank"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-title",
    attrs: {
      "title": "Commission Report"
    }
  }, [_vm._v("Commission Report")])])], 1) : _vm._e(), _vm._v(" "), (_vm.sampling === 1 && _vm.is_client !== true) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(sampling-reports)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/sampling-reports',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-piggy-bank"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-title",
    attrs: {
      "title": "Commission Report"
    }
  }, [_vm._v("Sampling Report")])])], 1) : _vm._e(), _vm._v(" "), (_vm.is_client !== true) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(customers)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/customers',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-users"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-title",
    attrs: {
      "title": "CRM"
    }
  }, [_vm._v("CRM")])])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.is_master === true || _vm.is_manager === true) ? _c('li', {
    staticClass: "nav-item nav-dropdown",
    class: {
      'open': _vm.active_locations
    }
  }, [_vm._m(10), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items",
    class: {
      'nav-dropdown-items-left': !_vm.active_locations, 'dbimportant': _vm.active_locations
    }
  }, [(_vm.is_master === true || (_vm.permissions.indexOf('12') >= 0 && _vm.features.indexOf('locations') >= 0)) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(locations)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/locations',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v(" Locations\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.permissions.indexOf('12') >= 0 && _vm.features.indexOf('location_map') >= 0)) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(location-map)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/location-map'
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-map-marker-alt"
  }), _vm._v(" Location Map\n                        ")])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.is_master === true || _vm.is_manager === true) ? _c('li', {
    class: ['nav-item', 'link-master-data', {
      'active-menu': _vm.isActiveMenu('(promoters)')
    }]
  }, [_c('router-link', {
    class: ['nav-link', {
      'active': _vm.isActiveMenu(_vm.promoter_path)
    }],
    attrs: {
      "to": {
        path: '/promoters',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-user-tie"
  }), _vm._v(" Promoters\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.is_manager === true && ((_vm.permissions.indexOf('168') >= 0 || _vm.permissions.indexOf('172') >= 0) &&
    _vm.features.indexOf('sales') >= 0 && _vm.userinfo.client_id === null))) ? _c('li', {
    staticClass: "nav-item nav-dropdown",
    class: {
      'open': _vm.active_sales_settings
    }
  }, [_vm._m(11), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items ",
    class: {
      'nav-dropdown-items-left': !_vm.active_sales_settings, 'dbimportant': _vm.active_sales_settings
    },
    staticStyle: {
      "top": "auto",
      "bottom": "0"
    }
  }, [(_vm.is_master === true || (_vm.userinfo.client_id === null && _vm.permissions.indexOf('168') >= 0 && _vm.features.indexOf('sales') >= 0)) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(sales-target-location)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/sales-target-location?page=1'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-map-pin"
  }), _vm._v(" Per Location\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.userinfo.client_id === null && _vm.permissions.indexOf('172') >= 0 && _vm.features.indexOf('sales') >= 0)) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(sales-target-promoter)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/sales-target-promoter?page=1'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-user-tag"
  }), _vm._v(" Per Promoter\n                        ")])], 1) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.current_top_menu === 'settings' && _vm.is_manager === true),
      expression: "current_top_menu === 'settings' && is_manager === true"
    }],
    staticClass: "nav"
  }, [(_vm.is_master === true || _vm.is_manager === true) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(dashboard)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/settings",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-cogs"
  }), _vm._v(" Company Settings\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || _vm.is_manager === true) ? _c('li', {
    staticClass: "nav-item nav-dropdown",
    class: {
      'open': _vm.active_manage_users
    }
  }, [_vm._m(12), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items",
    class: {
      'nav-dropdown-items-left': !_vm.active_manage_users, 'dbimportant': _vm.active_manage_users
    }
  }, [(_vm.is_master === true || _vm.permissions.indexOf('1') >= 0) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(/users)')
    }
  }, [_c('router-link', {
    class: ['nav-link', {
      'active': _vm.isActiveMenu(_vm.active_company_settings)
    }],
    attrs: {
      "to": {
        path: '/users',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" Users\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || _vm.permissions.indexOf('1') >= 0) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(clientusers)')
    }
  }, [_c('router-link', {
    class: ['nav-link', {
      'active': _vm.isActiveMenu(_vm.clientusers_path)
    }],
    attrs: {
      "to": {
        path: '/clientusers',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-user-lock"
  }), _vm._v(" Clients\n                        ")])], 1) : _vm._e(), _vm._v(" "), ((_vm.is_master === true || _vm.permissions.indexOf('1') >= 0) && _vm.is_supervisor === false) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(assign-supervisor)')
    }
  }, [_c('router-link', {
    class: ['nav-link', {
      'active': _vm.isActiveMenu(_vm.assignsupervisor_path)
    }],
    attrs: {
      "to": {
        path: '/assign-supervisor',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-user-lock"
  }), _vm._v(" Assign Supervisor\n                        ")])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.is_master === true || _vm.is_manager === true) ? _c('li', {
    staticClass: "nav-item nav-dropdown",
    class: {
      'open': _vm.active_location_settings
    }
  }, [_vm._m(13), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items",
    class: {
      'nav-dropdown-items-left': !_vm.active_location_settings, 'dbimportant': _vm.active_location_settings
    }
  }, [(_vm.is_master === true || (_vm.permissions.indexOf('16') >= 0 && _vm.features.indexOf('clients') >= 0)) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(clients)')
    }
  }, [_c('router-link', {
    class: ['nav-link', {
      'active': _vm.isActiveMenu(_vm.client_paths)
    }],
    attrs: {
      "to": {
        path: '/clients',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-user-follow"
  }), _vm._v(" Clients\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.permissions.indexOf('84') >= 0 && _vm.features.indexOf('retailers') >= 0)) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(retailers)')
    }
  }, [_c('router-link', {
    class: ['nav-link', {
      'active': _vm.isActiveMenu(_vm.retailers_paths)
    }],
    attrs: {
      "to": {
        path: '/retailers',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "glyphicons glyphicons-industrial-zone"
  }), _vm._v(" Retailers\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || _vm.permissions.indexOf('188') >= 0) ? _c('li', {
    class: ['nav-item', 'link-master-data', {
      'active-menu': _vm.isActiveMenu('(planograms)')
    }]
  }, [_c('router-link', {
    class: ['nav-link', {
      'active': _vm.isActiveMenu(_vm.planogram_path)
    }],
    attrs: {
      "to": {
        path: '/planograms',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-image"
  }), _vm._v(" Planogram Pictures\n                        ")])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.is_manager === true && (_vm.plan === 2 || _vm.plan === 3 || _vm.plan === 4))) ? _c('li', {
    staticClass: "nav-item nav-dropdown",
    class: {
      'open': _vm.active_product_settings
    }
  }, [_vm._m(14), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items",
    class: {
      'nav-dropdown-items-left': !_vm.active_product_settings, 'dbimportant': _vm.active_product_settings
    }
  }, [(_vm.is_master === true || (_vm.permissions.indexOf('68') >= 0 && _vm.features.indexOf('product_packing') >= 0)) ? _c('li', {
    class: ['nav-item', 'link-master-data', {
      'active-menu': _vm.isActiveMenu('(product-packings)')
    }, {
      'open': _vm.isActiveMenu(_vm.productpacking_paths)
    }]
  }, [_c('router-link', {
    class: ['nav-link', {
      'active': _vm.isActiveMenu(_vm.productpacking_paths)
    }],
    attrs: {
      "to": {
        path: '/product-packings',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-box"
  }), _vm._v(" Packings\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.permissions.indexOf('8') >= 0 && _vm.features.indexOf('product_category') >= 0)) ? _c('li', {
    class: ['nav-item', 'link-master-data', {
      'active-menu': _vm.isActiveMenu('(product-categories)')
    }, {
      'open': _vm.isActiveMenu(_vm.productcategory_paths)
    }]
  }, [_c('router-link', {
    class: ['nav-link', {
      'active': _vm.isActiveMenu(_vm.productcategory_paths)
    }],
    attrs: {
      "to": {
        path: '/product-categories',
        query: {
          page: 1
        }
      }
    }
  }, [_c('i', {
    staticClass: "icon-handbag"
  }), _vm._v(" Categories\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.permissions.indexOf('60') >= 0 && _vm.features.indexOf('product_brand') >= 0)) ? _c('li', {
    class: ['nav-item', 'link-master-data', {
      'active-menu': _vm.isActiveMenu('(product-brands)')
    }, {
      'open': _vm.isActiveMenu(_vm.productbrand_paths)
    }]
  }, [_c('router-link', {
    class: ['nav-link', {
      'active': _vm.isActiveMenu(_vm.productbrand_paths)
    }],
    attrs: {
      "to": {
        path: '/product-brands',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-bag"
  }), _vm._v(" Brands\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.permissions.indexOf('4') >= 0 && _vm.features.indexOf('products') >= 0)) ? _c('li', {
    class: ['nav-item', 'link-master-data', {
      'active-menu': _vm.isActiveMenu('(products)')
    }, {
      'open': _vm.isActiveMenu(_vm.product_paths)
    }]
  }, [_c('router-link', {
    class: ['nav-link', {
      'active': _vm.isActiveMenu(_vm.product_paths)
    }],
    attrs: {
      "to": {
        path: '/products',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "glyphicons glyphicons-shopping-cart"
  }), _vm._v(" Products\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.permissions.indexOf('108') >= 0 && _vm.features.indexOf('store_model') >= 0)) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(store-model)')
    }
  }, [_c('router-link', {
    class: ['nav-link', {
      'active': _vm.isActiveMenu(_vm.store_model_paths)
    }],
    attrs: {
      "to": {
        path: '/store-model',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-store"
  }), _vm._v("Store Models\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.permissions.indexOf('144') >= 0 && _vm.features.indexOf('price_lists') >= 0)) ? _c('li', {
    class: ['nav-item', 'link-master-data', {
      'active-menu': _vm.isActiveMenu('(price-lists)')
    }, {
      'open': _vm.isActiveMenu(_vm.pricelists_paths)
    }]
  }, [_c('router-link', {
    class: ['nav-link', {
      'active': _vm.isActiveMenu(_vm.pricelists_paths)
    }],
    attrs: {
      "to": {
        path: '/price-lists',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-comment-dollar"
  }), _vm._v(" Price Lists\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.permissions.indexOf('64') >= 0 && _vm.features.indexOf('product_mapping') >= 0)) ? _c('li', {
    class: ['nav-item', 'link-master-data', {
      'active-menu': _vm.isActiveMenu('(product-mapping-codes)')
    }, {
      'open': _vm.isActiveMenu(_vm.productmapping_paths)
    }]
  }, [_c('router-link', {
    class: ['nav-link', {
      'active': _vm.isActiveMenu(_vm.productmapping_paths)
    }],
    attrs: {
      "to": {
        path: '/product-mapping-codes',
        query: {
          page: 1
        }
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-pencil-ruler"
  }), _vm._v("Mapping\n                        ")])], 1) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.current_top_menu === 'user profile'),
      expression: "current_top_menu === 'user profile'"
    }],
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(dashboard)')
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/profile',
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" Profile\n                ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    class: {
      'active-menu': _vm.isActiveMenu('(dashboard)')
    }
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logout($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" Logout")])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-link nav-dropdown-toggle",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-exchange"
  }), _vm._v("Company")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-link nav-dropdown-toggle",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-exchange"
  }), _vm._v("Users")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-link nav-dropdown-toggle",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fas fa-calendar-plus"
  }), _vm._v("Actions")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-link nav-dropdown-toggle",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fas fa-chart-line"
  }), _vm._v("Reports")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-link nav-dropdown-toggle",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fas fa-map-marked-alt"
  }), _vm._v("Locations")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-link nav-dropdown-toggle",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fas fa-calendar-plus"
  }), _vm._v("Actions")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-link nav-dropdown-toggle",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fas fa-chart-line"
  }), _vm._v("Reports")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-link nav-dropdown-toggle",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fas fa-map-marked-alt"
  }), _vm._v("Locations")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-link nav-dropdown-toggle",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fas fa-calendar-plus"
  }), _vm._v("Actions")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-link nav-dropdown-toggle",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fas fa-chart-line"
  }), _vm._v("Reports")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-link nav-dropdown-toggle",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fas fa-map-marked-alt"
  }), _vm._v("Locations")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-link nav-dropdown-toggle",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fas fa-dollar-sign"
  }), _vm._v("Sales Targets")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-link nav-dropdown-toggle",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fas fa-users-cog"
  }), _vm._v("Manage Users")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-link nav-dropdown-toggle",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fas fa-sliders-h"
  }), _vm._v("Location Settings")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-link nav-dropdown-toggle",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fas fa-toolbox"
  }), _vm._v("Product Settings")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6734580a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = 1390
// module chunks = 244